// 单文件引入方式

import Calendar from './ZuiCalendar.vue'

export default {
  install(Vue) {
    Vue.component('ZuiCalendar', Calendar)
  }
}

export { Calendar }
